'use strict';
Object.defineProperty(exports, '__esModule', { value: true });
var prefix = 'fasds';
var iconName = 'compass-drafting';
var width = 512;
var height = 512;
var aliases = ["drafting-compass"];
var unicode = 'f568';
var svgPathData = ['M6.6 240l55.4-32c9.8 17 21.9 32.6 35.7 46.4-11.2 18.8-22.4 37.5-33.6 56.3-22.7-20.3-42.1-44.1-57.5-70.6zM155.3 365.9L188 309.5c21.5 6.8 44.3 10.5 68 10.5s46.6-3.7 68-10.5c34.5-11 65.3-30.1 90.3-55.1 13.8-13.8 25.8-29.4 35.7-46.4l55.4 32c-15.3 26.5-34.8 50.3-57.5 70.6-26.5 23.7-57.4 42.6-91.3 55.2-31.3 11.7-65.3 18.1-100.7 18.1s-69.4-6.4-100.7-18.1z', 'M343.4 135.7c5.5-12.1 8.6-25.5 8.6-39.7 0-53-43-96-96-96s-96 43-96 96c0 14.1 3.1 27.6 8.5 39.7L0 417.8 0 512 91.4 476.2 256 192 324 309.5c34.5-11 65.3-30.1 90.3-55.1L343.4 135.7zM448 310.7c-26.5 23.7-57.4 42.6-91.3 55.2l63.9 110.3 91.4 35.8 0-94.2-64-107.1zM224 96a32 32 0 1 1 64 0 32 32 0 1 1 -64 0z'];

exports.definition = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.faCompassDrafting = exports.definition;
exports.prefix = prefix;
exports.iconName = iconName;
exports.width = width;
exports.height = height;
exports.ligatures = aliases;
exports.unicode = unicode;
exports.svgPathData = svgPathData;
exports.aliases = aliases;